import { render } from "./AssetImage.vue?vue&type=template&id=e191058a&scoped=true"
import script from "./AssetImage.vue?vue&type=script&lang=js"
export * from "./AssetImage.vue?vue&type=script&lang=js"

import "./AssetImage.vue?vue&type=style&index=0&id=e191058a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e191058a"]])

export default __exports__